<template>
  <el-container class="quality">
    <el-header class="header-style">
      <el-divider content-position="left">服务质检管理</el-divider>
      <el-row class="mb-10">
        <el-col :span="20">
          <el-select
            v-model="searchArr.companyId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司名称筛选公司"
            size="mini"
            clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="handleSearchCompanyChange"
          >
            <el-option
              v-for="searchCompany in searchCompanies"
              :key="searchCompany.id"
              :label="searchCompany.company_name"
              :value="searchCompany.id"
            >
            </el-option>
          </el-select>
          <el-date-picker
            :picker-options="ysyTypeInPickerOptions"
            v-model="searchArr.created_at"
            size="mini"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="录入日期"
            end-placeholder="结束日期"
            @change="handleCreatedAtChange"
          ></el-date-picker>
          <el-popover placement="bottom-start" v-model="visible" width="320">
            <el-form :model="searchArr" ref="searchForm" label-width="80px">
              <el-form-item label="录入人" prop="created_id">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.created_id"
                  placeholder="请选择录入人"
                  :options="adminUsers"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="状态" prop="status">
                <el-select
                  v-model="searchArr.status"
                  style="width: 100%"
                  placeholder="请选择状态"
                  clearable
                  size="mini"
                >
                  <el-option label="待处理" :value="0"></el-option>
                  <el-option label="完成" :value="1"></el-option>
                  <el-option label="失败" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="责任部门" prop="branch_id">
                <el-select
                  v-model="searchArr.branch_id"
                  style="width: 100%"
                  placeholder="请选择责任部门"
                  filterable
                  clearable
                  size="mini"
                >
                  <el-option
                    v-for="branch in branchs"
                    :key="branch.id"
                    :label="branch.name"
                    :value="branch.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="责任人" prop="created_id">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.responsible_id"
                  placeholder="请选择责任人"
                  :options="adminUsers"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="客户情况" prop="condition">
                <el-select
                  v-model="searchArr.condition"
                  style="width: 100%"
                  placeholder="请选择状态"
                  clearable
                  size="mini"
                >
                  <el-option label="接受认可" :value="1"></el-option>
                  <el-option label="不接受" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
        <el-col :span="4" class="text-r">
          <el-button type="primary" size="mini" @click="handleAddOpen">录入</el-button>
        </el-col>
      </el-row>
      <el-collapse v-model="activeNames" style="border-top: none" id="myschedule">
        <el-collapse-item title="" name="2">
          <template slot="title">
            <span style="color: #409eff">数据统计</span>
          </template>
          <el-row :gutter="12">
            <el-col :span="6">
              <el-card shadow="hover">
                <div class="item-title">客户状态</div>
                <div class="item-title">
                  <div class="item-content">
                    <el-row
                      type="flex"
                      justify="center"
                      :gutter="12"
                      class="item-row"
                      style="color: #f56c6c"
                    >
                      <el-col :span="14" style="white-space: nowrap">待处理</el-col>
                      <el-col :span="10" style="color: #f56c6c">{{
                        calculate.undo
                      }}</el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      class="item-row"
                      justify="center"
                      :gutter="12"
                      style="color: #409eff"
                    >
                      <el-col :span="14" style="white-space: nowrap">已完成</el-col>
                      <el-col :span="10" style="color: #409eff">{{
                        calculate.completed
                      }}</el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      class="item-row"
                      justify="center"
                      :gutter="12"
                      style="color: #67c23a"
                    >
                      <el-col :span="14" style="white-space: nowrap">已失败</el-col>
                      <el-col :span="10" style="color: #67c23a">{{
                        calculate.failed
                      }}</el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card shadow="hover">
                <div class="item-title">客户情况</div>
                <div class="item-title">
                  <div class="item-content">
                    <el-row
                      type="flex"
                      class="item-row"
                      style="color: #409eff"
                      justify="center"
                      :gutter="12"
                    >
                      <el-col :span="14" style="white-space: nowrap">已接受</el-col>
                      <el-col :span="10" style="color: ">{{ calculate.accepted }}</el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      class="item-row"
                      style="color: #67c23a"
                      justify="center"
                      :gutter="12"
                    >
                      <el-col :span="14" style="white-space: nowrap">不接受</el-col>
                      <el-col :span="10" style="color: #67c23a">{{
                        calculate.unaccepted
                      }}</el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      class="item-row"
                      style="color: "
                      justify="center"
                      :gutter="12"
                    >
                      <el-col :span="14" style="white-space: nowrap">&nbsp;</el-col>
                      <el-col :span="10" style="color: ">&nbsp;</el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 326px)" :data="pageData" size="mini" border style="width: 100%">
        <el-table-column label="公司名" width="150" fixed>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.company.company_name" placement="top">
              <el-link
                type="primary"
                :underline="false"
                class="hide-style"
                @click="openCompanyCom(scope.row)"
                >{{ scope.row.company.company_name }}</el-link
              >
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="复制" placement="top"
              ><i
                class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copySome(scope.row.company.company_name)"
              ></i
            ></el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="责任部门">
          <template slot-scope="scope">
            <span>{{ scope.row.branch.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="责任人">
          <template slot-scope="scope">
            <span v-if="scope.row.responsible">{{ scope.row.responsible.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="录入人">
          <template slot-scope="scope">
            <span>{{ scope.row.founder.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="原因">
          <template slot-scope="scope">
            <el-tooltip :content="getReason(scope.row.complaint)" placement="top">
              <span class="hide-style">{{ getReason(scope.row.complaint) }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status"></el-table-column>
        <el-table-column label="客户情况" prop="condition"></el-table-column>
        <el-table-column label="备注" prop="remark">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.remark" placement="top">
              <span class="hide-style">{{ scope.row.remark }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="录入时间" width="140">
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.created_at" placement="top"> -->
              <!-- <span class="hide-style">{{ scope.row.created_at }}</span> -->
              <date-formatter :date-value="scope.row.created_at"></date-formatter>
            <!-- </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="处理" placement="top">
              <el-button
                :type="scope.row.status !== '待处理' ? 'success' : 'primary'"
                :icon="scope.row.status !== '待处理' ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                circle
                @click="handleOpen(scope.$index, scope.row)"
                :disabled="scope.row.status !== '待处理'"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                @click="
                  handleWxChatOpen(
                    scope.row.wx_work_chat_com,
                    scope.row.company.company_name
                  )
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
                :disabled="scope.row.wx_work_chat_com ? false : true"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="查看详情" placement="top">
              <el-button
                size="mini"
                icon="el-icon-search"
                type="primary"
                circle
                @click="handleShowOpen(scope.row)"
              >
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="mt-10 text-r"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-size="pageOption.pageSize"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :total="pageOption.total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="添加"
      :visible.sync="addDrawer"
      direction="rtl"
      :before-close="handleAddClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="addForm"
          ref="addForm"
          :rules="addRules"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="公司名称" prop="companyId">
            <el-select
              v-model="addForm.companyId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司字号筛选公司"
              size="mini"
              clearable
              :remote-method="remoteCompanyMethod"
              :loading="loading"
            >
              <el-option
                v-for="company in companies"
                :key="company.id"
                :label="company.company_name"
                :value="company.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任部门" prop="branch_id">
            <el-select
              v-model="addForm.branch_id"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="branch in branchs"
                :key="branch.id"
                :label="branch.name"
                :value="branch.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任人" prop="responsible_id">
            <el-cascader
              style="width: 100%"
              v-model="addForm.responsible_id"
              placeholder="请选择责任人"
              :options="adminUsers"
              size="mini"
              :props="{ expandTrigger: 'hover' }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="原因" prop="reason">
            <el-select
              v-model="addForm.reason"
              multiple
              placeholder="责任人"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="complaint in complaints"
                :key="complaint.id"
                :label="complaint.reason"
                :value="complaint.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="addForm.remark" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-row>
            <el-col :span="24">
              <el-card shadow="hover">
                <el-upload
                  multiple
                  ref="upload"
                  action="#"
                  :headers="uploadHeader"
                  accept="image/png, image/jpeg, image/gif"
                  :limit="5"
                  :on-preview="handlePreview"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :file-list="addImgList"
                  list-type="picture"
                  :auto-upload="false"
                >
                  <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
                </el-upload>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="padding-top: 0.4rem">
            <el-input
              v-paste="handleParse"
              type="textarea"
              placeholder="请点击此处，再粘贴复制的截图"
            />
          </el-row>
        </div>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button type="primary" size="mini" @click="submitAddUpload('addForm')"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="详情"
      :visible.sync="showDrawer"
      direction="rtl"
      :before-close="handleShowClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-tabs type="border-card">
          <el-tab-pane label="信息">
            <el-row>
              <el-col :span="24">
                <el-card class="box-card">
                  <div slot="header" class="clearfix"><span>备注说明</span></div>
                  <div>
                    <span>{{ showData.remark }}</span>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row class="mt-10">
              <el-col :span="24">
                <el-card class="box-card">
                  <div slot="header" class="clearfix"><span>截图</span></div>
                  <div>
                    <el-row :gutter="20">
                      <el-col v-for="(img, index) in showImages" :key="index" :span="4">
                        <el-image
                          style="width: 100%x"
                          :src="img.url"
                          :preview-src-list="showImgUrls"
                        ></el-image>
                      </el-col>
                    </el-row>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row class="mt-10">
              <el-col :span="24">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>处理说明 {{ showData.handle_at }}</span>
                  </div>
                  <div>
                    <span
                      >{{ showData.handler ? showData.handler + "：" : ""
                      }}{{ showData.process_result }}</span
                    >
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row class="mt-10">
              <el-col :span="24">
                <el-card class="box-card">
                  <div slot="header" class="clearfix"><span>处理截图</span></div>
                  <div>
                    <el-row :gutter="20">
                      <el-col
                        v-for="(img, index) in processImages"
                        :key="index"
                        :span="4"
                      >
                        <el-image
                          style="width: 100%x"
                          :src="img.url"
                          :preview-src-list="processImaUrls"
                        ></el-image>
                      </el-col>
                    </el-row>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="处理"
      :visible.sync="handleDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="handleForm"
          ref="handleForm"
          :rules="handleRules"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="处理状态" prop="status">
            <el-select
              v-model="handleForm.status"
              placeholder="处理状态"
              clearable
              size="mini"
            >
              <el-option label="完成" :value="1"></el-option>
              <el-option label="失败" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户情况" prop="condition">
            <el-select
              v-model="handleForm.condition"
              placeholder="处理状态"
              clearable
              size="mini"
            >
              <el-option label="接受认可" :value="1"></el-option>
              <el-option label="不接受" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理结果" prop="process_result">
            <el-input
              v-model="handleForm.process_result"
              clearable
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-row>
            <el-col :span="24">
              <el-card shadow="hover">
                <el-upload
                  multiple
                  ref="upload"
                  action="#"
                  :headers="uploadHeader"
                  accept="image/png, image/jpeg, image/gif"
                  :limit="5"
                  :on-preview="handleUpPreview"
                  :on-change="handleUpChange"
                  :on-remove="handleUpRemove"
                  :file-list="handleImgList"
                  list-type="picture"
                  :auto-upload="false"
                >
                  <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
                </el-upload>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="padding-top: 0.4rem">
            <el-input
              v-paste="handleUpParse"
              type="textarea"
              placeholder="请点击此处，再粘贴复制的截图"
            />
          </el-row>
          <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
            <el-col>
              <el-button
                type="primary"
                size="mini"
                @click="submitHandleUpload('handleForm')"
                >确定</el-button
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      size="50%"
      :before-close="handleChatBeforeClose"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <chat :chatId="chatId" :chatName="chatName"></chat>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import Chat from "common/Chat";
import CompanyInfo from "common/CompanyInfo";
import WxWorkChat from "common/WxWorkChat";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import DateFormatter from 'common/DateFormatter'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "Quality",
  mixins: [fscDate],
  components: {
    Chat,
    CompanyInfo,
    WxWorkChat,
    DateFormatter
  },
  data() {
    return {
      uploadHeader: {
        Authorization: "Bearer " + localStorage.tenantToken,
      },
      searchArr: {
        companyId: "",
        created_at: "",
        created_id: "",
        status: "",
        branch_id: "",
        condition: "",
        responsible_id: "",
      },
      searchLoading: false,
      searchCompanies: [],
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      loading: false,
      companies: [],
      branchs: [],
      adminUsers: [],
      complaints: [],
      addDrawer: false,
      formData: null,
      addForm: {
        companyId: null,
        branch_id: null,
        responsible_id: null,
        reason: [],
        remark: "",
      },
      addRules: {
        companyId: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        branch_id: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      addImgList: [],
      showDrawer: false,
      showImages: [],
      showImgUrls: [],
      showData: {
        remark: "",
        process_result: "",
        handler: "",
        handle_at: "",
      },
      handleDrawer: false,
      handleForm: {
        index: null,
        id: null,
        status: 1,
        condition: 1,
      },
      handleRules: {
        process_result: [{ required: true, message: "请填写处理结果", trigger: "blur" }],
        status: [{ required: true, message: "请选择处理状态", trigger: "blur" }],
        condition: [{ required: true, message: "请选择客户情况", trigger: "blur" }],
      },
      handleImgList: [],
      handleFormData: null,
      processImages: [],
      processImaUrls: [],
      visible: false,
      chatDrawer: false,
      chatId: "",
      chatName: "",
      // 初始化企业微信群
      wxWorkChatId: null,
      // 初始化企业微信群数据
      wxWorkchatCompany: null,
      // 公司组件的显示与隐藏
      companyInfoDrawer: false,
      companyComId: null,
      // 企业微信聊天记录显示与隐藏
      wxChatDrawer: false,
      // 数据统计面板
      activeNames: ["1"],
      calculate: [],
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getPageData() {
      this.$axios
        .get(
          "/api/admin/we_chat_qualities?page=" +
            this.pageOption.currentPage +
            this.searchStr
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.pageData.data;
            this.pageOption.total = data.data.pageData.total;
            this.branchs = data.data.departments;
            this.adminUsers = data.data.adminUsers;
            this.complaints = data.data.complaints;
            this.calculate = data.data.countData;
          }
        });
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchItemCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany_a?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleAddOpen() {
      this.formData = new FormData();
      this.addDrawer = true;
    },
    handleAddClose(done) {
      this.formData = null;
      this.$refs["addForm"].resetFields();
      done();
    },
    handlePreview(file) {},
    handleChange(file, fileList) {
      this.addImgList = fileList;
    },
    handleRemove(file, fileList) {
      this.addImgList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.addImgList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.addImgList.length < 5) {
            that.addImgList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addImgList.length > 0) {
            this.addImgList.forEach((file) => this.formData.append("file[]", file.raw));
          }
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/admin/we_chat_qualities", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.getPageData();
              this.$message.success(data.msg);
              this.formData = null;
              this.addDrawer = false;
              this.$refs[formName].resetFields();
              this.addImgList = [];
            }
          });
        }
      });
    },
    handleShowOpen(row) {
      this.showImages = row.imgs;
      for (var i = 0; i < this.showImages.length; i++) {
        this.showImgUrls.push(this.showImages[i].url);
      }
      this.showData.remark = row.remark;
      this.showData.process_result = row.process_result;
      this.showData.handler = row.handler ? row.handler.username : "";
      this.showData.handle_at = row.handle_at;
      this.processImages = row.process_imgs;
      for (var j = 0; j < this.processImages.length; j++) {
        this.processImaUrls.push(this.processImages[j].url);
      }
      this.showDrawer = true;
    },
    handleShowClose(done) {
      this.showImages = [];
      this.showImgUrls = [];
      this.showData.remark = "";
      this.showData.process_result = "";
      this.showData.handler = "";
      this.showData.handle_at = "";
      this.processImages = [];
      this.processImaUrls = [];
      done();
    },
    handleOpen(index, row) {
      this.handleForm.index = index;
      this.handleForm.id = row.id;
      this.handleFormData = new FormData();
      this.handleDrawer = true;
    },
    handleUpPreview(val) {},
    handleUpChange(file, fileList) {
      this.handleImgList = fileList;
    },
    handleUpRemove(file, fileList) {
      this.handleImgList = fileList;
      this.handleFormData = null;
      this.handleFormData = new FormData();
      this.handleImgList.forEach((file) =>
        this.handleFormData.append("file[]", file.raw)
      );
      for (let key in this.handleForm) {
        this.handleFormData.append(key, this.handleForm[key]);
      }
    },
    handleUpParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.handleImgList.length < 5) {
            that.handleImgList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitHandleUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.handleImgList.length > 0) {
            this.handleImgList.forEach((file) =>
              this.handleFormData.append("file[]", file.raw)
            );
          }
          for (let key in this.handleForm) {
            this.handleFormData.append(key, this.handleForm[key]);
          }
          this.$axios
            .post(
              "/api/admin/we_chat_qualities/process_result/" + this.handleForm.id,
              this.handleFormData
            )
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.pageData[this.handleForm.index].status =
                  this.handleForm.status === 1 ? "完成" : "失败";
                this.pageData[this.handleForm.index].condition =
                  this.handleForm.condition === 1 ? "接受认可" : "不接受";
                this.handleDrawer = false;
                this.handleImgList = [];
                this.handleFormData = null;
                this.handleForm.index = null;
                this.handleForm.id = null;
                this.handleForm.process_result = "";
                this.handleForm.status = 1;
                this.handleForm.condition = 1;
                this.getPageData();
                this.$message.success(data.msg);
              }
            });
        }
      });
    },
    handleClose(done) {
      this.handleImgList = [];
      this.handleFormData = null;
      this.handleForm.index = null;
      this.handleForm.id = null;
      this.handleForm.process_result = "";
      this.handleForm.status = 1;
      this.handleForm.condition = 1;
      done();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange() {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleCreatedAtChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.pageOption.currentPage = 1;
      this.visible = false;
      this.getPageData();
    },
    submitForm(formName) {
      this.visible = false;
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    showMessages(chat, chatName) {
      this.chatDrawer = true;
      if (chat) {
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatName = chatName;
        });
      }
    },
    handleChatBeforeClose(done) {
      this.chatId = "";
      this.chatName = "";
      done();
    },
    getReason(complaint) {
      let reason = "";
      if (complaint.length === 0) return reason;

      for (var i = 0; i < complaint.length; i++) {
        reason += complaint[i].reason + "，";
      }

      return reason;
    },
    // 点击公司名称显示公司详情
    openCompanyCom(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.company_id;
      });
    },
    // 调用企业微信聊天记录
    handleWxChatOpen(chat, companyName) {
      console.log(chat, companyName);
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    // 关闭企业微信聊天记录弹窗
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.getPageData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-popper .el-form-item
  margin-bottom: 0
.quality
  marginLeft()
  max-height: 100vh
  .header-style
    z-index: 2
    height: 137px !important
    padding: 0px !important
  .main-style
    z-index: 1
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 15px
  .mb-10
    margin-bottom: .2rem
  .mt-10
    margin-top: .2rem
  .text-c
    text-align: center
  .text-r
    text-align: right
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.drawer-content
  padding: 0 .4rem 0 .4rem
  .el-select
    width: 100%
#myschedule >>> .el-collapse-item__wrap
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: none;
.header
  height: 50px;
  margin-bottom: 10px;
  text-align: center;
  background-color: #fff;
  padding-top: 20px;
.header span
  padding: 5px 8px;
  color: #fff;
  background-color: #409eff;
  border-radius: 4px;
  margin-right: 5px;
  cursor: pointer;
.item-title
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
.item-row
  margin-top: 0.2rem;
</style>



// WEBPACK FOOTER //
// src/pages/conversation/Quality.vue